import { CaseData, PartyModel } from "@/types/case";
import { SummaryPartyModel } from "@/calcs/documents/summary";
import { getCashMedicalSupportLevel, getCashMedicalRate } from "./worksheet1Calcs";
import { Worksheet1PartyModel } from "@/calcs/documents/worksheet1";
// import { debugLog } from "@/utils/debug";
import { roundTo } from "@/calcs/utils";

export function calcSummaryParty(caseData: CaseData, party: PartyModel | null, worksheet1Party: Worksheet1PartyModel): SummaryPartyModel {

    const cashMedicalSupportLevel = getCashMedicalSupportLevel(worksheet1Party?.totalsSection?.adjustedNetMonthlyIncome ?? 0.0);
    const rate = getCashMedicalRate(cashMedicalSupportLevel, caseData.children.count ?? 0);
    const reasonableCashMedicalSupportAmount = roundTo(rate * (worksheet1Party?.sourcesAndAmountsSection?.total ?? 0.0) / 12.0, 2);

    // debugLog('adjustedNetMonthlyIncome: ', worksheet1Party?.totalsSection?.adjustedNetMonthlyIncome);
    // debugLog('children count: ', caseData.children.count);
    // debugLog('cashMedicalSupportLevel: ', cashMedicalSupportLevel);
    // debugLog('gross annual income: ', worksheet1Party?.sourcesAndAmountsSection?.total);
    // debugLog('reasonableCashMedicalSupportAmount: ', reasonableCashMedicalSupportAmount);

    const rv: SummaryPartyModel = {
        reasonableCashMedicalSupportAmount: reasonableCashMedicalSupportAmount
    };

    return rv;
}